import "./Spinner.css";

const Spinner = () => (
  <div className="spinner-center">
    <svg className="spinner-svg" viewBox="0 0 50 50">
      <circle
        className="spinner-circle"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
      />
    </svg>
  </div>
);

export default Spinner;
